import React from "react";
import {ReactSession} from "react-client-session";
import {toast} from "react-toastify";
import OtpInput from 'react-otp-input';

import { Helpers } from "../config/Helpers";
import queryString from "query-string";
import PasswordStrengthBar from 'react-password-strength-bar';

let timer = '';

class Register extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            urlParam: queryString.parse(window.location.search),
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            phone: '',
            otp: '',
            secureText: true,
            expiredSecond: 120,
        }
    }

    componentDidMount() {
        if(this.state.sessUserCode){
            window.location.href = './';
        }
    }

    componentWillUnmount() {
        if(timer){
            clearInterval(timer);
            timer = '';
        }
    }

    startTimer = () => {
        if(!timer && this.state.expiredSecond > 0){
            timer = setInterval(this.countDown, 1000);
        }
    };

    countDown = () => {
        let second = parseInt(this.state.expiredSecond) - 1;
        this.setState({ expiredSecond: second });

        if(second <= 0){
            clearInterval(timer);
            timer = '';
            this.setState({ expiredSecond: 120 });
        }
    };

    secondsToHms = (d) => {
        const m = Math.floor(d % 3600 / 60);
        const s = Math.floor(d % 60);
        return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    };

    handleOTP = () => {
        if(timer){
            toast.error('Harap menunggu sampai waktu selesai untuk membuat OTP baru');
            return;
        }

        if(this.state.phone){
            Helpers.requestOTP(
                'request',
                this.state.phone,
                ''
            ).then(res => {
                if(res.length > 0){
                    if(res[0].alert == 'success'){
                        this.startTimer();
                    }

                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }else{
            toast.error(Helpers.MSG_ERROR_FORM);
        }
    };

    viewPassword = () => {
        this.setState({secureText: !this.state.secureText});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let error = false;
        let message = '';
        if (this.state.password.length < 8) {
            message += "Your password needs a minimum of eight characters. ";
            error = true;
        }
        if (this.state.password.search(/[a-z]/) == -1) {
            message += "Your password needs at least one lower case letter. ";
            error = true;
        }
        if (this.state.password.search(/[A-Z]/) == -1) {
            message += "Your password needs at least one upper case letter. ";
            error = true;
        }
        if (this.state.password.search(/[0-9]/) == -1) {
            message += "Your password needs at least one number. ";
            error = true;
        }
        if (this.state.password.search(/[!@#$%^&*]/) == -1) {
            message += "Your password needs at least one symbol. ";
            error = true;
        }
        if (error) {
            toast.error(message);
            return;
        }

        Helpers.register(
            this.state.firstName + ' ' + this.state.lastName,
            this.state.phone,
            this.state.email,
            this.state.password,
            this.state.otp
        ).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    this.setState({
                        email: '',
                        password: '',
                        firstName: '',
                        lastName: '',
                        phone: '',
                        otp: ''
                    });

                    setTimeout(() => {
                        if(this.state.urlParam.voucher){
                            window.location.href = '/login?voucher='+this.state.urlParam.voucher;
                        }else{
                            window.location.href = './login';
                        }
                    }, 1000);
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    render() {
        return (
            <>
                <main className="main pages auth-page-wrap">
                    <div className="auth-wrap">
                        <div className="auth-hero">
                            <div className="auth-hero-icon">
                                <i className="fi-rs-user-add"></i>
                            </div>
                            <h1 className="auth-hero-title">Buat Akun Baru</h1>
                            <p className="auth-hero-subtitle">Daftar sekali, belanja harga grosir selamanya</p>
                        </div>

                        <div className="auth-card">
                            <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input required type="text" value={this.state.firstName} onChange={e => this.setState({firstName: e.target.value})}
                                           placeholder="Nama Depan"/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input required type="text" value={this.state.lastName} onChange={e => this.setState({lastName: e.target.value})}
                                           placeholder="Nama Belakang"/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-envelope auth-input-icon"></i>
                                    <input required type="email" value={this.state.email} onChange={e => this.setState({email: e.target.value})}
                                           placeholder="Email"/>
                                </div>
                                <div className="auth-input-group mb-10">
                                    <i className="fi-rs-lock auth-input-icon"></i>
                                    <input required type={(this.state.secureText) ? 'password' : 'text'} value={this.state.password} onChange={e => this.setState({password: e.target.value})}
                                           placeholder="Password"/>
                                    <i className={'fi-rs-' + (this.state.secureText ? 'eye' : 'eye-crossed') + ' auth-input-icon-right'} onClick={() => {this.viewPassword()}}></i>
                                </div>
                                <div className="auth-strength-bar mb-15">
                                    <PasswordStrengthBar password={this.state.password} />
                                    <small className="auth-hint">Minimal 8 karakter, kombinasi huruf besar, kecil, angka, dan simbol.</small>
                                </div>

                                <div className="auth-otp-request mb-15">
                                    <div className="auth-input-group" style={{flex: 1}}>
                                        <i className="fi-rs-smartphone auth-input-icon"></i>
                                        <input required type="number" value={this.state.phone} onChange={e => this.setState({phone: e.target.value})}
                                               min={0}
                                               placeholder="Nomor HP"/>
                                    </div>
                                    <button type="button" className="auth-btn-otp" onClick={() => {this.handleOTP()}}>
                                        {
                                            timer ? this.secondsToHms(this.state.expiredSecond) : 'Kirim OTP'
                                        }
                                    </button>
                                </div>

                                <div className="auth-otp-input mb-20">
                                    <OtpInput
                                        inputStyle="auth-otp-box"
                                        containerStyle="auth-otp-container"
                                        value={this.state.otp}
                                        onChange={otp => this.setState({otp})}
                                        numInputs={6}
                                        isInputSecure={true}
                                        separator={<span>&nbsp;</span>}
                                    />
                                </div>

                                <button type="submit" className="auth-btn-primary" name="register">Daftar</button>

                                <div className="auth-divider">
                                    <span></span>
                                    <p>atau masuk akun</p>
                                    <span></span>
                                </div>

                                <a href="./login" className="auth-btn-outline">
                                    Masuk
                                </a>
                            </form>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default Register;
